<script lang="ts">
  import RisoColors from "./RisoColors.svelte";

  export let hash: string;
</script>

<div>
  <p>
    The ideal printing device for Reverie is the risograph, as it will add
    multiple random imperfections - alignment, filling, fuzzy borders, etc. The
    14 possible colours of Reverie are ones regularly found in risographs.
  </p>

  <p>
    <a href="../reverie-vector/?hash={hash}" target="_blank"
      >Vector rendering for PDF</a
    >
  </p>

  Risograph printers often need 1 separate file per color. In the prepared file
  for printing:
  <ul>
    <li>
      The first page contains the complete rendering (expected output) in vector
      format.
    </li>
    <li>
      Each following page corresponds to one specific color (but in black and
      white), in vector format, in the following order: <br />
      <RisoColors /> <br />It is normal to have most pages plain white as
      renderings do not use all colors.
    </li>
    <li>
      The rendering is not vertically centered to ease the cutting into a square
      (only one margin to remove).
    </li>
    <li>Format is A3 as A3 size is the standard size used by risographs.</li>
  </ul>

  To transform it into a vector PDF, print using your browser print (ctrl + P):
  <ul>
    <li>Size A3</li>
    <li>Landscape</li>
    <li>Save to PDF</li>
    <li>Put "Fit to page width"</li>
  </ul>

  <p>
    Successful prints have been done in France with <a
      href="https://maisonriso.fr/">"Maison Riso" (Nice, France)</a
    >:
    <img
      src="../reverie/img/riso_print/riso_print1.jpg"
      alt="Riso sample print for Reverie by Pandelune"
    />
  </p>
</div>
